import React from 'react';
import { Star, MapPin, DollarSign, BookOpen, ExternalLink, Calculator } from 'lucide-react';

const TopUniversities = ({ universitiesData }) => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {universitiesData?.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Explore world-class universities known for academic excellence and research innovation
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {universitiesData?.universities?.map((university, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">
              {/* University Header */}
              <div className="bg-primary-cream p-6 text-primary-brown">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center">
                    <Star className="w-5 h-5 text-yellow-400 mr-2" />
                    <span className="text-sm text-black font-medium">{university.ranking}</span>
                  </div>
                  <ExternalLink className="w-5 h-5 opacity-70 group-hover:opacity-100 transition-opacity duration-200" />
                </div>
                <h3 className="text-xl font-bold mb-2">{university.name}</h3>
                <div className="flex items-center text-black">
                  <MapPin className="w-4 h-4 mr-1" />
                  <span className="text-sm">{university.location}</span>
                </div>
              </div>

              {/* University Content */}
              <div className="p-6">
                {/* Specialties */}
                <div className="mb-4">
                  <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                    <BookOpen className="w-4 h-4 mr-2 text-blue-600" />
                    Popular Programs
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {university.specialties?.map((specialty, specIndex) => (
                      <span key={specIndex} className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-1 rounded-full">
                        {specialty}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Tuition Range */}
                <div className="mb-6">
                  <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <span className="font-medium text-gray-700 flex items-center">
                      <DollarSign className="w-4 h-4 mr-1 text-green-600" />
                      Tuition Fee
                    </span>
                    <span className="font-bold text-green-600">{university.tuitionRange}</span>
                  </div>
                </div>

                {/* Action Buttons */}
                {/* <div className="space-y-3">
                  <button className="w-full bg-primary-brown text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium">
                    View Programs
                  </button>
                  <button className="w-full border border-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-50 transition-colors duration-200 font-medium">
                    Get Admission Info
                  </button>
                </div> */}
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-16">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-xl p-8 text-white">
            <div className="max-w-4xl mx-auto text-center">
              <h3 className="text-2xl font-bold mb-4">
                Need Help Choosing the Right University? 
              </h3>   
              <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
                Our team of experts is here to guide you through the process and help you find the perfect university for your academic and career goals.
              </p>
             
            </div>
          </div>   
        </div>   
      </div>   
    </section>   
  );
};   

export default TopUniversities;   